import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'bulma/css/bulma.css';
import './hoc/i18n/i18n';
import axios from 'axios';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import * as serviceWorker from './serviceWorker';
import App from './containers/App';
import Store from './store';
import Spinner from './components/Spinner/Spinner';

axios.interceptors.request.use(req => {
  const token = Store.getState().authentication.token;
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
    req.headers['Content-Type'] = 'application/json';
    req.headers['X-Owner'] = req.headers['X-Owner'] || '*';
  }
  return req;
});

ReactDOM.render(
  <Provider store={Store}>
    <BrowserRouter>
      <Suspense fallback={<Spinner />}>
        <App />
      </Suspense>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();